import React, { useState } from "react";
import ForgotPassword from "./ForgotPassword";
import VerifyOtp from "./VerifyOtp";
import ResetPassword from "./ResetPassword";
import "../styles/ForgotFlow.css";

export default function ForgotFlow() {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [tempToken, setTempToken] = useState("");

  const handleNext = (nextStep, data = {}) => {
    if (data.email) setEmail(data.email);
    if (data.tempToken) setTempToken(data.tempToken);
    setStep(nextStep);
  };

  return (
    <div className="forgot-container">
      {step === 1 && <ForgotPassword onNext={handleNext} />}
      {step === 2 && <VerifyOtp email={email} onNext={handleNext} />}
      {step === 3 && <ResetPassword tempToken={tempToken} onNext={handleNext} />}
    </div>
  );
}
